export default {"src":"/_next/static/media/socialicon-twitter.96d40ddd.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};